module.exports = __webpack_public_path__ + "images/Benefits_435dfe4.png";